import Attribute from './Attribute'
import DomAttributes from './DomAttributes'
import CSSProperties from './CSSProperties'
import VmTextAttribute from './VmTextAttribute'
import VmViewAttribute from './VmViewAttribute'
export {default as VmInputAttributes} from './VmInputAttributes'

export {DomAttributes, CSSProperties, VmTextAttribute, VmViewAttribute}
export default Attribute
